
// Store Locations
let all_store_locations = document.querySelectorAll('.store-location-item-main');
if(all_store_locations.length > 0){
  all_store_locations[0].classList.add('active');

  all_store_locations.forEach((store_location)=> {
    store_location.addEventListener('click', ()=> {
      
      // all_store_locations.forEach((store_location)=> {
      //   store_location.classList.remove('active');
      // })

      store_location.classList.toggle('active');
    })
  })
}

// Product Thumbnial Add To Cart

let all_product_thumbnails_atc_btn = document.querySelectorAll('.product-thumbnail-atc');
if(all_product_thumbnails_atc_btn.length > 0){
  all_product_thumbnails_atc_btn.forEach((thumbnails_atc_btn)=> {
    thumbnails_atc_btn.addEventListener('click', ()=> {
      let var_id = thumbnails_atc_btn.closest('.thumbnail__caption').getAttribute('data-id');
      let form_data = {
          'items': [{
            'id': var_id,
            'quantity': 1
          }]
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(form_data)
      })
      .then(response => {
        return response.json();
      })
      .then(newRes =>{
        let current_count = Number(document.querySelector('.header-cart__count').innerHTML);
        document.querySelector('.header-cart__count').innerHTML = current_count + 1;
        document.querySelector('.header-cart__count-mob').innerHTML = current_count + 1;
        document.querySelector('.header-cart__count').style.cssText = 'display: flex !important';
        document.querySelector('.header-cart__count-mob').style.cssText = 'display: flex !important';
        
        if(window.location.href.includes('cart')){
            location.reload();
        }
      })
    })
  })
}

// PDP Description Accordian
let product_description_head = document.querySelectorAll('.description-heading');
product_description_head.forEach((description_head)=> {
  description_head.addEventListener('click', ()=> {
    description_head.closest('.product-block--description').classList.toggle('active');
  })
})

// FBT Add To Cart
let all_fbt_atc = document.querySelectorAll('.fbt_atc');
let all_fbt_master_selector = document.querySelectorAll('fbt_master_selector');
let all_fbt_select = document.querySelectorAll('.fbt_select');

if(all_fbt_atc.length > 0){
  
  // Updating soldout variants
  if(all_fbt_master_selector.length > 0){
    all_fbt_master_selector.forEach((fbt_master_selector)=>{
      let fbt_master_selector_soldout_options = fbt_master_selector.querySelectorAll('.soldout-option');
      if(fbt_master_selector_soldout_options.length > 0){
        fbt_master_selector_soldout_options.forEach((fbt_master_selector_soldout_option)=>{
          fbt_master_selector.closest('.fbt_product_options_main').querySelector('.fbt_select').querySelector(`option[data-title="${fbt_master_selector_soldout_option.getAttribute('data-title')}"]`).setAttribute('disabled','');
        })
      }
    })
  }

  // Updating data-id
  if(all_fbt_select.length > 0){
    all_fbt_select.forEach((fbt_select)=> {
      fbt_select.addEventListener('change', ()=> {
        let current_selected_option = fbt_select.options[fbt_select.selectedIndex].getAttribute('data-title');
        let current_data_id = fbt_select.closest('.fbt_product_options_main').querySelector('.fbt_master_selector').querySelector(`option[data-title="${current_selected_option}"]`).getAttribute('data-id');
        fbt_select.closest('.fbt_product_options_main ').querySelector('.fbt_atc').setAttribute('data-id', current_data_id);
      })
    })
  }
  
  all_fbt_atc.forEach((fbt_atc)=> {
    fbt_atc.addEventListener('click', ()=> {
      if(fbt_atc.hasAttribute('data-id')){
        let var_id = fbt_atc.getAttribute('data-id');
        let form_data = {
            'items': [{
              'id': var_id,
              'quantity': 1
            }]
        }
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(form_data)
        })
        .then(response => {
          return response.json();
        })
        .then(newRes =>{
          if(newRes.status != 422){
            let current_count = Number(document.querySelector('.header-cart__count').innerHTML);
            document.querySelector('.header-cart__count').innerHTML = current_count + 1;
            document.querySelector('.header-cart__count').style.cssText = 'display: flex !important';

            document.querySelector('.header-cart__count-mob').innerHTML = current_count + 1;
            document.querySelector('.header-cart__count-mob').style.cssText = 'display: flex !important';
          }
          else{
            fbt_atc.closest('.fbt_item').querySelector('.fbt_cart_error').classList.add('active');
            setTimeout(()=>{
              fbt_atc.closest('.fbt_item').querySelector('.fbt_cart_error').classList.remove('active');
            },5000)
          }
        })
      }
    })
  })
}

// Mobile Filter

let filter_btn = document.querySelectorAll('.filter-by');
if(filter_btn.length > 0){

  let close_filter_icon = document.querySelector('.filter-close-icon').querySelector('.icon');
  
  // Filter Active
  filter_btn[0].addEventListener('click', ()=> {
    filter_btn[0].closest('.sidebar-section').querySelector('.faceted-filter-form').classList.add('active');
  })

  // Filter Close

  close_filter_icon.addEventListener('click', ()=>{
    close_filter_icon.closest('.faceted-filter-form').classList.remove('active');
  })
}


// Single variant max qty
if(document.querySelector('.purchase-details__buttons')){
  if(document.querySelector('.purchase-details__buttons').querySelector('input[value="/cart"]')){
    let all_atc_btns = document.querySelectorAll('.button--add-to-cart');
    if(all_atc_btns.length > 0){
      all_atc_btns.forEach((atc_btn)=> {
        atc_btn.addEventListener('click', (e)=> {
          e.preventDefault();
          let var_id = atc_btn.closest('.shopify-product-form').querySelector('.variant-selection').getAttribute('variant');
          let var_qty = Number(atc_btn.closest('.purchase-details').querySelector('.quantity-input').value);
  
          let form_data = {
            'items': [{
              'id': var_id,
              'quantity': var_qty
            }]
          }
  
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(form_data)
          })
          .then(response => {
            return response.json();
          })
          .then(newRes =>{
            if(newRes.status == 422){
              if(newRes.message != 'Cart Error'){
                window.location.replace("/cart");
              }
              else{
                document.querySelector('.custom-cart-warning').innerHTML = "";
                document.querySelector('.custom-cart-warning').innerHTML = newRes.description;
                document.querySelector('.custom-cart-warning').classList.add('active');

                setTimeout(()=> {
                  document.querySelector('.custom-cart-warning').classList.remove('active');
                }, 5000);
              }
            }
            else{
              window.location.replace("/cart");
            }
          })
        })
      })
    }
  }
}

// Collections All url redirect
if(window.location.href.includes('collections/all')){
  if(document.querySelectorAll('.sort_by').length > 0){
    if(window.location.href.includes('?')){
      
    }
    else{
      let location_url = window.location.href;
      let site_url = location_url.split('/collections/all');
      console.log("site_url --->", site_url);
      let new_url = `${site_url[0]}/collections/all/?sort_by=created-descending`;
      window.location.replace(new_url);
    }
  }
}














